exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n#tRespuestas th[data-v-4130a3d1],\n#tRespuestas td[data-v-4130a3d1] {\n  padding: 12px;\n  text-align: center;\n  color: rgba(0, 0, 0, 0.54);\n  width: 800px;\n}\n", ""]);

// exports
